import React from 'react';
import { WxbIcon } from '../Icon/Icon';
import './Stepper.css';

export interface WxbStep {
  key?: React.Key;
  label: React.ReactNode;
  desc?: React.ReactNode;
  status: 'done' | 'curr' | 'todo';
}

export interface WxbStepperProps extends React.OlHTMLAttributes<HTMLOListElement> {
  steps: WxbStep[];
}

const STATUS_LABELS: Record<WxbStep['status'], string> = {
  done: '已完成',
  curr: '当前步骤',
  todo: '未开始',
};

export const WxbStepper: React.FC<WxbStepperProps> = ({
  steps,
  className = '',
  'aria-label': ariaLabel = '流程进度',
  ...props
}) => (
  <ol
    {...props}
    className={`wxb-stepper ${className}`}
    aria-label={ariaLabel}
  >
    {steps.map((step, index) => (
      <li
        key={step.key ?? index}
        className={`wxb-stepper-stage is-${step.status}`}
        aria-current={step.status === 'curr' ? 'step' : undefined}
      >
        <span className="wxb-stepper-ic" aria-hidden="true">
          {step.status === 'done' && <WxbIcon name="released" size={12} />}
        </span>
        <span className="wxb-stepper-lbl">{step.label}</span>
        {step.desc && <span className="wxb-stepper-desc">{step.desc}</span>}
        <span className="wxb-stepper-sr-only">{STATUS_LABELS[step.status]}</span>
      </li>
    ))}
  </ol>
);
